import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import userApi from 'apis/userApi';
import BetRecord from 'components/bet-record/BetRecord';
import DatePicker from 'components/date-picker/DatePicker';
import LoadingIcon from 'components/loading/LoadingIcon';
import Modal from 'components/modal/Modal';
import { FundTransSearchPayload, FundTransferItem, FundTransferType } from 'models/fundTransferModel';
import moment from 'moment';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import accountStyles from './account-option.style';

function FundAccountTransfer() {
    const [fundTypeList, setFundTypeList] = useState<FundTransferType[]>([]);
    const [fundTypeSelect, setFunTypeSelect] = useState<FundTransferType>({} as FundTransferType);
    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 00:00:00`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 23:59:59`));
    const [accountList, setAccountList] = useState<FundTransferItem[] | null>(null);
    const [betRecordId, setBetRecordId] = useState<string | null>(null);

    const [loading, setLoading] = useState(false);

    //mã số cược
    const [wid, setWid] = useState('');

    //mã số biến động
    const [fundId, setfundId] = useState('');

    useEffect(() => {
        const initFundTran = async () => {
            try {
                const { data } = await userApi.initAgentZbBean({});
                if (!data.msg) {
                    setFundTypeList(data.typelist);
                    if (data.typelist.length > 0) {
                        setFunTypeSelect(data.typelist[0]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        initFundTran();
    }, []);

    const handleChangeFundType = (values: string) => {
        const fundSelect = fundTypeList.find((item) => item.value === values);
        if (fundSelect) {
            setFunTypeSelect(fundSelect);
        }
    };

    const searchFund = async () => {
        const payload: FundTransSearchPayload = {
            type: fundTypeSelect.value,
            starttime: startTime ? moment(startTime).format('yyyy-MM-DD HH:mm:ss') : '',
            endtime: endTime ? moment(endTime).format('yyyy-MM-DD HH:mm:ss') : '',
            wid,
            id: fundId,
        };
        setLoading(true);
        try {
            const { data } = await userApi.balanceChangeSearch(payload);
            if (!data.msg) {
                const accountData = data.reslist.map((item: FundTransferItem) => ({
                    ...item,
                    showDetail: [1, 5, 8, 9, 830, 850, 890, 13, 3001, 3002, 3003, 4001, 4002].includes(item.opttype),
                    isNote: Number(item.opttype) === 13 && item.remark.trim() !== '',
                }));
                setAccountList(accountData);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelBet = () => {};

    return (
        <>
            <div className={`${styles.wrap}`}>
                <div className={styles.containerBox}>
                    <div className={styles.itemBox} style={{ marginRight: 40 }}>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Loại Biến Động Số Dư</label>
                            <div className={styles.wrapInput}>
                                <select value={fundTypeSelect.value} onChange={(e) => handleChangeFundType(e.target.value)}>
                                    {fundTypeList.map((item, index) => (
                                        <option value={item.value} key={index}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Mã Số Cược</label>
                            <div className={styles.wrapInput}>
                                <input value={wid} onChange={(e) => setWid(e.target.value)} type="text" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={styles.wrapInput}>
                                <DatePicker showTime noneStyle dateSelect={startTime} showSecond onSelectDate={(date) => setStartTime(date)} />
                            </div>
                        </div>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Mã Số Biến Động</label>
                            <div className={styles.wrapInput}>
                                <input value={fundId} onChange={(e) => setfundId(e.target.value)} type="text" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div className={styles.groupInput}>
                            <label className={styles.none}>{'___'}</label>
                            <div className={styles.groupInputTo}>
                                <div className="centerView">
                                    <label htmlFor="">Đến</label>
                                </div>
                                <div className={styles.wrapInput}>
                                    <DatePicker showTime noneStyle dateSelect={endTime} showSecond onSelectDate={(date) => setEndTime(date)} />
                                </div>
                            </div>
                        </div>

                        <button type="submit" className={`${styles.btnSubmit}`} onClick={searchFund}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>

                <div className={styles.containerTable}>
                    <div className={styles.table}>
                        <div className="row">
                            <div className="title col" style={{ flex: '0 0 200px' }}>
                                Mã số biến động
                            </div>
                            <div className="title col">Thành viên</div>
                            <div className="title col">Thời gian</div>
                            <div className="title col">Loại</div>
                            <div className="title col">Thu nhập</div>
                            <div className="title col">Chi</div>
                            <div className="title col">Số dư trước</div>
                            <div className="title col">Số dư sau</div>
                            <div className="title col">Chi tiết</div>
                        </div>
                        {accountList?.length ? (
                            accountList.map((mem) => (
                                <div className="row" key={mem.id}>
                                    <p className="col" style={{ flex: '0 0 200px' }}>
                                        {mem.id}
                                    </p>
                                    <p className="col">{mem.loginname}</p>
                                    <p className="col">{moment(mem.inserttime).format('DD/MM/yyyy HH:mm')}</p>
                                    <p className="col">{mem.opttypename}</p>
                                    <p className="col text-success">{new Intl.NumberFormat().format(mem.income)}</p>
                                    <p className="col text-error">{new Intl.NumberFormat().format(mem.pay)}</p>
                                    <p className="col">{new Intl.NumberFormat().format(Number(mem.beforebalance))}</p>
                                    <p className="col">{new Intl.NumberFormat().format(Number(mem.afterbalance))}</p>
                                    <p className="col">
                                        {mem.showDetail && (
                                            <span className="btn-detail" style={{ padding: '4px 0', width: '100%', display: 'block' }} onClick={() => setBetRecordId(mem.wid)}>
                                                Xem
                                            </span>
                                        )}
                                    </p>
                                </div>
                            ))
                        ) : (
                            <div className="no-data"></div>
                        )}
                    </div>
                </div>
            </div>
            <Modal isShow={Boolean(betRecordId)} onClose={() => setBetRecordId(null)} closeClickBackdrop width="60%" maxWidth="900px">
                <BetRecord onClose={() => setBetRecordId(null)} betRecordId={betRecordId} onCancelBet={handleCancelBet} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    groupTime: css`
        display: flex;
        gap: 16px;
    `,
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding: 20px;
    `,
    containerBox: css`
        background-color: #f9f9f9;
        padding: 15px 40px 8px;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        margin-bottom: 15px;
        border-left: 3px solid #ebc85e;
        display: flex;
        justify-content: space-between;
    `,

    itemBox: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        label {
            font-weight: 300;
            font-size: 17px;
            width: 100%;
        }
    `,
    wrapInput: css`
        color: black;
        display: flex;
        flex: 1;
        input {
            border: none;
            height: 40px;
            border-bottom: 1px solid black;
            padding-left: 10px;
            background-color: white;
            width: 100%;
        }
        select {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
            width: 100%;
            color: black;
            box-shadow: none;
            outline: none;
            padding-left: 5px;
            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    `,
    groupInputTo: css`
        position: relative;
        display: flex;
        align-items: flex-end;
        margin-bottom: 4px;
        width: 100%;
        .centerView {
            width: 40px;
            text-align: center;
        }
    `,
    none: css`
        color: transparent;
    `,
    groupInput: css`
        padding-bottom: 20px;
        position: relative;
        label {
            display: block;
            margin-bottom: 4px;
            padding-left: 2px;
        }
        input {
            width: 100%;
        }
    `,
    btnSubmit: css`
        background: #ffad33 !important;
        border-radius: 3px !important;
        border: 1px solid #c9820a !important;
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 130px;
        margin-left: 40px;
        margin-bottom: 20px;
    `,
    containerTable: css`
        background-color: #f2f2f2;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        border-radius: 5px;
        padding: 4px 4px 18px;
        margin-bottom: 100px;
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
};

export default FundAccountTransfer;
